import type { SVGProps } from 'react';

export const Duration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="20px"
    version="1.1"
    viewBox="0 0 20 20"
    width="20px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'Duration'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-57.000000, -51.000000)">
        <g transform="translate(57.000000, 51.000000)">
          <rect height="20" width="20" x="0" y="0"></rect>
          <g>
            <polygon
              fill="#8C8C8C"
              fillRule="nonzero"
              points="13.0373303 15 9.375 11.4147287 9.375 5 10.364819 5 10.364819 11.0077519 13.75 14.3217054"
            ></polygon>
            <path
              d="M10,20 C4.48897796,20 0,15.511022 0,10 C0,4.48897796 4.48897796,0 10,0 C15.511022,0 20,4.48897796 20,10 C20,15.511022 15.511022,20 10,20 Z M10,0.961923848 C5.01002004,0.961923848 0.961923848,5.01002004 0.961923848,10 C0.961923848,14.98998 5.01002004,19.0380762 10,19.0380762 C14.98998,19.0380762 19.0380762,14.98998 19.0380762,10 C19.0380762,5.01002004 14.98998,0.961923848 10,0.961923848 Z"
              fill="#8C8C8C"
              fillRule="nonzero"
              id="Shape"
            ></path>
            <rect height="20" width="20" x="0" y="0"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
